export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const AUTH_BOOTSTRAP_FINISHED = 'AUTH_BOOTSTRAP_FINISHED';
export const PERSIST_REHYDRATE = 'persist/REHYDRATE';
